import { ALL_GROUPS_TABS, type GroupTabName } from '@communities/groups-layer/utils/constants'

export const CONFIGURABLE_TAB_BY_ROUTE_SEGMENT: Readonly<Record<string, GroupTabName>> = {
  learning: 'LEARNING',
  events: 'EVENTS',
  leaderboard: 'LEADERBOARD',
  members: 'MEMBERS',
  'member-list': 'MEMBERS',
  'members-list': 'MEMBERS',
}

/** First-level segments under [groupSlug] that are valid group routes (not redirect-to-home). */
export const VALID_GROUP_FIRST_SEGMENTS = new Set([
  ...Object.values(ALL_GROUPS_TABS).map(tab => tab.url?.split('/')[1]),
  'channels', // /[groupSlug]/channels/:channelSlug – not a tab
  'conversations', // /[groupSlug]/conversations – not a tab
  'content-unavailable', // /[groupSlug]/content-unavailable – banned-member fallback (route guard target)
])

/**
 * URL segment for the banned-member fallback page. Centralized so the route
 * guard, middleware, page file, and tests all agree.
 */
export const CONTENT_UNAVAILABLE_SEGMENT = 'content-unavailable'
